import React from "react";
import styles from "./styles.module.scss";

export const QuestionBox = ({ children }) => {
  return <div className={styles.root}>{children}</div>;
};
